import { useEffect } from 'react';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface useGetDocumentProps {
  isError: Error | null;
  openPDF: () => void;
  isLoading: boolean;
  mutation: UseMutationResult<string, Error, void>;
}

export function openDocumentPDF(id: string): useGetDocumentProps {
  const apiUrl = import.meta.env['VITE_SPICEROAD_URL'] + '/v1/documents';

  const mutation = useMutation({
    mutationFn: () =>
      spiceroad
        .get(`/v1/documents/token/${id}`, { responseType: 'text' })
        .then((res) => res.data),
    mutationKey: ['getDocument', id],
  });

  const openNewWindow = () =>
    window.open(`${apiUrl}/jwt/${mutation.data}`, '_blank');

  const openPDF = () => mutation.mutate();

  useEffect(() => {
    mutation.data && openNewWindow();
  }, [mutation.data]);

  return {
    isError: mutation.error,
    isLoading: mutation.isPending,
    openPDF,
    mutation,
  };
}

export default openDocumentPDF;
